import Promise from 'bluebird';
import $ from 'jquery';
import _ from 'underscore';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';
import {
  CHANNEL_TYPES,
  APPLY_ACTION_TYPES,
  RECOMMENDATION_TYPES,
  APPLY_USERINPUT_TYPES,
  ADINSIGHT_LOG_ACTION_TYPE,
  RECOMMENDATION_DISMISS_FEEDBACK_TYPE,
  getRecommendationPreferences,
  saveRecommendationPreferences,
  CROSS_LEVEL_TYPES,
  FILTERBY,
  ORDERBY_DIRECTION,
  PAGINATION_ORDERBY,
  groupUserInputs,
  RECOMMENDATION_CATEGORIES,
  getRecommendationCache,
  RECOMMENDATION_SUMMARY_TOP_NUMBER,
} from '@bingads-webui-campaign/recommendation-core';
import { CAMPAIGN_TYPES } from '@bingads-webui-campaign/recommendation-preferences';
import { handleRecommendationNotification } from '@bingads-webui-campaign/recommendation-notification';
import { RECOMMENDATION_TYPES_SUPPORT_NEW_DISMISS_FORM } from '@bingads-webui-campaign-react/recommendation-dismiss-feedback';
import { filterByOpportunityId, removeFilter } from './filter-helper';

export class RecommendationGridService {
  constructor(
    recommendationService,
    channel,
    recommendationType,
    campaignType,
    view,
    onEvent,
    logOpportunityEvent,
    context,
    guid,
    isMCC,
    setData,
    setDataFromDetails,
    IsRecommendationCacheDetailPageDataEnabled = false
  ) {
    this.recommendationService = recommendationService;
    this.recommendationType = recommendationType;
    this.campaignType = campaignType;
    this.view = view;
    this.handleRecommendationNotification = handleRecommendationNotification;
    this.filterByOpportunityId = filterByOpportunityId;
    this.removeFilter = removeFilter;
    this.onEvent = onEvent;
    this.logOpportunityEvent = logOpportunityEvent;
    this.context = context;
    this.guid = guid;
    this.gridRecCount = null;
    this.version = null;
    this.isMCC = isMCC;
    this.opportunityCount = 0;
    this.channel = channel ||
      (isMCC ? CHANNEL_TYPES.MCCRECOMMENDATION : CHANNEL_TYPES.RECOMMENDATION);
    this.benchMarkers = [];
    this.setData = setData;
    this.setDataFromDetails = setDataFromDetails;
    this.IsRecommendationCacheDetailPageDataEnabled = IsRecommendationCacheDetailPageDataEnabled;
  }

  getFilterBy(orderByDirection) {
    if (_.isUndefined(orderByDirection)) {
      return FILTERBY.LESS_THAN;
    }
    if (orderByDirection === ORDERBY_DIRECTION.ASCENDING) {
      return FILTERBY.GREATER_THAN;
    }
    return FILTERBY.LESS_THAN;
  }

  getBenchMarker(pageOffset) {
    this.benchMarkers = this.benchMarkers.slice(0, pageOffset);
    return this.benchMarkers[this.benchMarkers.length - 1];
  }

  formatBenchMarker(data) {
    if (_.isEmpty(data)) {
      return {};
    }
    return {
      RecommendationType: _.last(data).OpportunityType,
      DataVersion: _.last(data).Version,
      AccountId: _.last(data).Target.AccountId,
      OpportunityIdsInString: _.map(
        _.last(data).Opportunities,
        opportunity => opportunity.OpportunityId
      ),
    };
  }

  getPaginationOrderBy(orderBy) {
    if (_.isUndefined(orderBy)) {
      return PAGINATION_ORDERBY.DEFAULT;
    }

    const orderByArray = orderBy[0].split('/');
    return orderByArray[orderByArray.length - 1];
  }

  getDetailPageSetting({
    offset,
    orderBy,
    limit,
  }) {
    return {
      OrderBy: this.getPaginationOrderBy(_.first(orderBy)),
      FilterType: this.getFilterBy(_.first(orderBy) && _.first(orderBy)[1]),
      FilterBenchmark: this.getBenchMarker(offset / limit),
      PageSize: limit,
    };
  }

  getGridData({ data, campaignAdGroups, op }) {
    this.setData(data, campaignAdGroups, this.setDataFromDetails);
    const recommendationData = _.result(this.context, 'Category', '') === RECOMMENDATION_CATEGORIES.DISMISSED
      && !_.isEmpty(data.DismissTabSummaries) ? data.DismissTabSummaries : data.value;
    let gridData;
    if (_.isEmpty(recommendationData)) {
      gridData = [];
      gridData.totalCount = 0;
      this.onEvent('refreshSummary');
    } else {
      gridData = _.first(recommendationData).Recommendations.slice();
      gridData.totalCount = _.first(recommendationData).RecommendationsCount;
      gridData.version = _.first(recommendationData).Version;
      this.opportunityCount = _.first(recommendationData).OpportunitiesCount;
    }

    if (op.offset
      && (
        this.version !== gridData.version
        || gridData.length === 0
        || gridData.totalCount <= op.offset
      )
    ) {
      // todo
      // force pagination plugin to page 1
      // then grid will fetch new data and update totalCount
      gridData.totalCount = 1;
    } else {
      if (this.recommendationType !== RECOMMENDATION_TYPES.IMAGE_EXTENSION) {
        let FromUICache = false;
        if (this.IsRecommendationCacheDetailPageDataEnabled
          && _.isUndefined(op.orderBy) && _.isUndefined(op.offset)
          && !_.isUndefined(getRecommendationCache('recommendation-summary-raw-data'))
        ) {
          const summaryData = getRecommendationCache('recommendation-summary-raw-data');
          const isDismissedTab = _.result(this.context, 'Category', '') === RECOMMENDATION_CATEGORIES.DISMISSED;
          const recommendations = _.find(
            isDismissedTab ? summaryData.data.DismissTabSummaries : summaryData.data.value,
            i => i.OpportunityType === this.recommendationType
          );
          FromUICache = recommendations.RecommendationsCount <= RECOMMENDATION_SUMMARY_TOP_NUMBER;
        }
        _.each(gridData, (opportunity) => {
          const oppData = opportunity.Opportunities[0] || {};
          const rejectedAd = _.first(oppData.RejectedAds) || _.first(oppData.RejectedKeywords)
            || {};
          this.logOpportunityEvent({
            opportunityId: opportunity.Opportunities[0].OpportunityId,
            campaignId: opportunity.Target.CampaignId,
            type: this.recommendationType,
            action: ADINSIGHT_LOG_ACTION_TYPE.VIEW,
            accountId: opportunity.Target.AccountId,
            context: {
              FlagId: _.chain(opportunity)
                .result('Opportunities')
                .result(0)
                .result('FlagId')
                .value(),
              OldFinalUrl: rejectedAd.FinalUrl,
              OldTrackingTemplate: rejectedAd.TrackingTemplate,
              FromUICache,
              RecommendationCount: this.opportunityCount,
            },
          });
        });
      }
      this.benchMarkers.push(this.formatBenchMarker(gridData));
    }
    this.gridRecCount = gridData.totalCount;
    this.version = gridData.version;
    return gridData;
  }

  findAll(op) {
    if (this.IsRecommendationCacheDetailPageDataEnabled
      && this.recommendationType !== RECOMMENDATION_TYPES.IMAGE_EXTENSION
      && _.isUndefined(op.orderBy) && _.isUndefined(op.offset)
      && !_.isUndefined(getRecommendationCache('recommendation-summary-raw-data'))) {
      const summaryData = getRecommendationCache('recommendation-summary-raw-data');

      const isDismissedTab =
        _.result(this.context, 'Category', '') === RECOMMENDATION_CATEGORIES.DISMISSED;

      // Put target recommendation data by recommendation type
      const type = this.recommendationType;
      const recommendations =
        _.find(
          isDismissedTab ? summaryData.data.DismissTabSummaries : summaryData.data.value,
          i => i.OpportunityType === type
        );

      // Get cache data when recommendation count <= count of recommendation summary data.
      if (recommendations.RecommendationsCount <= RECOMMENDATION_SUMMARY_TOP_NUMBER) {
        const detailData = isDismissedTab ?
          { DismissTabSummaries: [recommendations] } :
          { value: [recommendations] };
        const gridData = this.getGridData({
          data: detailData,
          campaignAdGroups: summaryData.campaignAdGroups,
          op,
        });
        return Promise.resolve(gridData);
      }
    }

    const orderby = _.map(op.orderBy, item => [item[0], item[1].toLocaleLowerCase()]);
    let detailPageSetting;
    if (_.isUndefined(op.offset) || op.offset === 0) {
      this.benchMarkers = [];
    } else {
      detailPageSetting = this.getDetailPageSetting(op);
    }
    const settingOptions = _.isEmpty(op.settingOptions) ? undefined : op.settingOptions;

    return this.recommendationService.getSummary({
      orderby,
      channel: this.channel,
      campaignType: this.campaignType,
      type: this.recommendationType,
      top: op.limit,
      skip: op.offset,
      filter: op.where,
      filterOpportunity: op.filterOpportunity,
      filterRecommendation: op.filterRecommendation,
      detailPageSetting,
      settingOptions,
    }).then(({ data, campaignAdGroups }) => {
      const gridData = this.getGridData({ data, campaignAdGroups, op });
      return gridData;
    });
  }

  findRepair(op) {
    return this.recommendationService.getSummary({
      campaignAdGroups: op.campaignAdGroups,
      // mcc does not support find repair
      // so we have to find repair in single account mode
      channel: CHANNEL_TYPES.RECOMMENDATION,
      campaignType: this.campaignType,
      type: this.recommendationType,
      settingOptions: op.settingOptions,
      accountId: op.accountId,
    }).then(({ data }) => {
      const recommendationData = _.result(this.context, 'Category', '') === RECOMMENDATION_CATEGORIES.DISMISSED
        && !_.isEmpty(data.DismissTabSummaries) ? data.DismissTabSummaries : data.value;
      const rowData = _.first(_.first(recommendationData).Recommendations);

      return rowData;
    });
  }

  // This function is for user to apply recommendation in action column or toolbar with/without updating recommendation from grid.
  getUserInputFromGrid(opportunity, recommendationType, userAction) {
    let userInput;
    switch (recommendationType) {
      case RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY:
      case RECOMMENDATION_TYPES.TRENDING_QUERY:
        userInput = {
          '@odata.type': APPLY_USERINPUT_TYPES[recommendationType],
          OpportunityId: opportunity.OpportunityId,
          NewBid: opportunity.NewBid,
          TargetAdGroupId: opportunity.NewAdGroupId,
          MatchType: opportunity.NewMatchType,
        };
        break;
      case RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD:
        userInput = {
          '@odata.type': APPLY_USERINPUT_TYPES[recommendationType],
          OpportunityId: opportunity.OpportunityId,
          NewBid: opportunity.NewBid,
          NewAdGroupId: opportunity.NewAdGroupId,
        };
        break;
      case RECOMMENDATION_TYPES.IMAGE_EXTENSION:
        userInput = {
          '@odata.type': APPLY_USERINPUT_TYPES[recommendationType],
          OpportunityId: opportunity.OpportunityId,
        };
        // This is sepcial requirement for image extension
        if (!_.isEmpty(opportunity.StockImages) && !_.isNull(opportunity.StockImages[0].ImageId)) {
          _.extend(userInput, {
            StockImages: [{
              ImageId: opportunity.StockImages[0].ImageId,
              AssociationMetadata: [{ SubType: 'LandscapeImageMedia' }],
            }],
          });
        }
        break;
      case RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS:
        userInput = {
          '@odata.type': APPLY_USERINPUT_TYPES[recommendationType],
          OpportunityId: opportunity.OpportunityId,
        };
        if (!_.isUndefined(opportunity.Param1)) {
          userInput = _.extend({}, userInput, { Param1: opportunity.Param1 });
        } else if (!_.isUndefined(opportunity.Param2)) {
          userInput = _.extend({}, userInput, { Param2: opportunity.Param2 });
        } else if (!_.isUndefined(opportunity.Param3)) {
          userInput = _.extend({}, userInput, { Param3: opportunity.Param3 });
        }
        break;
      case RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID:
        userInput = {
          '@odata.type': APPLY_USERINPUT_TYPES[recommendationType],
          OpportunityId: opportunity.OpportunityId,
          NewBid: opportunity.NewBid,
        };
        break;
      case RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER:
        userInput = {
          '@odata.type': APPLY_USERINPUT_TYPES[recommendationType],
          OpportunityId: opportunity.OpportunityId,
          Bid: opportunity.NewProductGroupBid,
          Budget: opportunity.NewBudget,
          CampaignName: opportunity.NewCampaignName,
          AdGroupName: opportunity.NewAdGroupName,
        };
        break;
      default:
        userInput = {
          '@odata.type': APPLY_USERINPUT_TYPES[recommendationType],
          OpportunityId: opportunity.OpportunityId,
        };
        break;
    }

    if (userAction === APPLY_ACTION_TYPES.REDISMISS
      || _.result(this.context, 'Category', '') === RECOMMENDATION_CATEGORIES.DISMISSED) {
      userInput.OpportunityHash = opportunity.OpportunityHash;
    }
    return userInput;
  }

  isUserModified(userInput) {
    const userModifiedInput = _.omit(userInput, (value, key) => _.isUndefined(value) || key === '@odata.type' || key === 'OpportunityId');

    return _.size(userModifiedInput) > 0;
  }

  showAsyncApplyModal(pollTask) {
    this.onEvent('showAsyncApplyModal', pollTask);
  }

  closeAsyncApplyModal() {
    this.onEvent('closeAsyncApplyModal');
  }

  hidePopupEditor() {
    $('.popup-editor').hide();
    $('.grid-popupeditor').hide();
  }

  apply({
    opportunities,
    userInputs = [],
    userAction = APPLY_ACTION_TYPES.ACCEPT,
    context = {},
    hasInlineError = _.noop,
    closeUiBlock = _.noop,
    reason,
  }) {
    this.hidePopupEditor();

    const type = this.recommendationType;

    if (_.isEmpty(userInputs)) {
      _.each(opportunities, (i) => {
        userInputs.push(this.getUserInputFromGrid(i, type, userAction));
      });
    }

    const campaignAdgroup = {};
    _.each(opportunities, (opt) => {
      const campaignId = opt.Target.CampaignId;
      const adGroupId = opt.Target.AdGroupId;

      if (!_.has(campaignAdgroup, campaignId) && campaignId) {
        campaignAdgroup[campaignId] = {};
      }
      if (_.isNumber(adGroupId)) {
        campaignAdgroup[campaignId][adGroupId] = true;
      }
    });

    // campaignAdGroupsByCampaign: [{"Key":953172033, "Value": ["332", '3232']}]
    // Key is campaignid, value is adgroupid list
    const campaignAdGroupsByCampaign =
      _.map(campaignAdgroup, (adgroupIds, campaignId) => ({
        Key: parseInt(campaignId, 10),
        Value: _.map(_.keys(adgroupIds), i => parseInt(i, 10)),
      }));

    // now applyMode in context align with which mt api called, may need to modify in the future
    const contextWithApplyMode = this.recommendationType === RECOMMENDATION_TYPES.IMAGE_EXTENSION ?
      _.extend({}, this.context, context, {
        ApplyMode: 'Individual',
        ImageSource: _.first(opportunities).ImageSourceStr,
        ShutterstockQuery: _.first(opportunities).ImageSourceStr === 'StockImage' ? _.first(_.first(opportunities).StockImages).Query : null,
        ShutterstockTotalCount: _.first(opportunities).ImageSourceStr === 'StockImage' ? _.first(_.first(opportunities).StockImages).TotalCount : null,
        ShutterstockImageId: _.first(opportunities).ImageSourceStr === 'StockImage' ? _.first(_.first(opportunities).StockImages).ImageId : null,
      }) :
      _.extend({}, this.context, context, { ApplyMode: 'Individual' });

    const op = {
      type,
      userInputs: this.isMCC ? groupUserInputs({ userInputs, opportunities }) : userInputs,
      userAction,
      channel: this.channel,
      campaignAdGroups: _.contains(CROSS_LEVEL_TYPES, type) ?
        this.getCampaignAdGroupsFromScope() : campaignAdGroupsByCampaign,
      handleRecommendationNotification: this.handleRecommendationNotification,
      view: this.view,
      filterByOpportunityId: this.filterByOpportunityId,
      removeFilter: this.removeFilter,
      context: contextWithApplyMode,
      guid: this.guid,
      hasInlineError,
      showAsyncApplyModal: pollTask => this.showAsyncApplyModal(pollTask),
      closeAsyncApplyModal: () => this.closeAsyncApplyModal(),
      closeUiBlock,
      reason,
      targetAccountId: _.first(opportunities).Target.AccountId,
    };

    if (this.recommendationType === RECOMMENDATION_TYPES.FIX_AD_DESTINATION
      && userAction === APPLY_ACTION_TYPES.ACCEPT) {
      _.each(opportunities, (opportunity) => {
        const rejectedAd = _.first(opportunity.RejectedAds)
          || _.first(opportunity.RejectedKeywords)
          || {};
        const { FinalUrl, TrackingTemplate } = userInputs[0] || {};
        this.logOpportunityEvent({
          opportunityId: opportunity.OpportunityId,
          campaignId: opportunity.Target.CampaignId,
          type: this.recommendationType,
          action: APPLY_ACTION_TYPES.ACCEPT,
          accountId: opportunity.Target.AccountId,
          context: {
            OldFinalUrl: rejectedAd.FinalUrl,
            OldTrackingTemplate: rejectedAd.TrackingTemplate,
            NewFinalUrl: (_.isNull(FinalUrl) || _.isUndefined(FinalUrl)) ?
              rejectedAd.FinalUrl : FinalUrl,
            NewTrackingTemplate: (_.isNull(TrackingTemplate) || _.isUndefined(TrackingTemplate)) ?
              rejectedAd.TrackingTemplate : TrackingTemplate,
          },
        });
      });
    }

    return this.recommendationService.track(op).then(() => {
      this.onEvent('refreshSummary', { isFromApplyOrDismiss: true });
    });
  }

  undismiss(op) {
    return this.apply(_.defaults(op, {
      userAction: APPLY_ACTION_TYPES.UNDISMISS,
    }));
  }

  dismiss(op) {
    return this.apply(_.defaults(op, {
      userAction: APPLY_ACTION_TYPES.DISMISS,
    }));
  }

  applyAll({
    recommendationType,
    opportunities = [],
    userAction = APPLY_ACTION_TYPES.ACCEPT,
    context = {},
    closeUiBlock = _.noop,
    totalRecommendationCount,
  }) {
    const campaignAdGroups = this.getCampaignAdGroupsFromScope();
    // now applyMode in context align with which mt api called, may need to modify in the future
    const contextWithApplyMode = _.extend({}, this.context, context, { ApplyMode: 'All' });
    const userInputs = [];

    _.each(opportunities, (opportunity) => {
      const userInput = this.getUserInputFromGrid(opportunity, recommendationType, userAction);

      if (this.isUserModified(userInput)) {
        userInputs.push(userInput);
      }
    });

    const op = {
      type: recommendationType,
      withAll: true,
      userAction,
      userInputs: this.isMCC ? groupUserInputs({ userInputs, opportunities }) : userInputs,
      campaignAdGroups,
      channel: this.channel,
      handleRecommendationNotification: this.handleRecommendationNotification,
      view: this.view,
      filterByOpportunityId: this.filterByOpportunityId,
      removeFilter: this.removeFilter,
      context: contextWithApplyMode,
      guid: this.guid,
      showAsyncApplyModal: pollTask => this.showAsyncApplyModal(pollTask),
      closeAsyncApplyModal: () => this.closeAsyncApplyModal(),
      closeUiBlock,
      totalRecommendationCount,
    };

    return this.recommendationService.track(op).then(() => {
      this.onEvent('refreshSummary', { isFromApplyOrDismiss: true });
    });
  }

  undismissAll(op) {
    return this.applyAll(_.defaults(op, {
      userAction: APPLY_ACTION_TYPES.UNDISMISS,
    }));
  }

  dismissAll(op) {
    return this.applyAll(_.defaults(op, {
      userAction: APPLY_ACTION_TYPES.DISMISS,
    }));
  }

  dismissFeedback(op) {
    const {
      deps,
      data: { preference, reason },
      rejectAutoApplySuggestedAds,
      context,
      isRedismissEnabled,
    } = op;
    const { type, expireTime } = preference;

    const name = rejectAutoApplySuggestedAds ?
      CAMPAIGN_TYPES.RejectAutoApplySuggestedAds :
      CAMPAIGN_TYPES.DismissFeedback;

    saveRecommendationPreferences(
      {
        [name]: { [type]: expireTime },
      },
      deps.preferencesService,
      this.isMCC
    );

    const reasonObj = JSON.parse(reason);
    if (isRedismissEnabled) {
      if (reasonObj.reasonIds && reasonObj.reasonIds.length !== 0) {
        this.logOpportunityEvent({
          type: type || '',
          action: ADINSIGHT_LOG_ACTION_TYPE.FEEDBACK,
          campaignId: this.recommendationService.scope.campaignId,
          input: reason,
          context,
        });

        const options = {
          userAction: APPLY_ACTION_TYPES.REDISMISS,
          reason: {
            ReasonId: _.first(reasonObj.reasonIds),
            ReasonNote: reasonObj.reasonNote,
          },
        };

        return this.apply(_.defaults(op, options));
      }
    } else if ((reasonObj.reasonIds && reasonObj.reasonIds.length !== 0) || (reasonObj.reasonNote && reasonObj.reasonNote !== '')) {
      this.logOpportunityEvent({
        type: type || '',
        action: ADINSIGHT_LOG_ACTION_TYPE.FEEDBACK,
        campaignId: this.recommendationService.scope.campaignId,
        input: reason,
        context,
      });
    }
    return true;
  }

  isShowFeedback(op) {
    const {
      deps,
      recommendationType: type,
      rejectAutoApplySuggestedAds,
      permissions,
    } = op;
    const isNewSupportedType = RECOMMENDATION_TYPES_SUPPORT_NEW_DISMISS_FORM[type];

    if (!RECOMMENDATION_DISMISS_FEEDBACK_TYPE[type] &&
      !isNewSupportedType) {
      return false;
    }

    if (isNewSupportedType && !permissions.IsRecommendationInProductFeedbackLoopEnabled) {
      return false;
    }
    const data = getRecommendationPreferences(deps.preferencesService);
    const preference = data[rejectAutoApplySuggestedAds ?
      CAMPAIGN_TYPES.RejectAutoApplySuggestedAds :
      CAMPAIGN_TYPES.DismissFeedback];
    const now = Date.now();
    const userLevelRejected =
      preference &&
      preference[type] &&
      now < preference[type];
    if (rejectAutoApplySuggestedAds || this.isMCC) {
      return !userLevelRejected;
    }
    const accountData = getRecommendationPreferences(deps.preferencesService, false);
    const accountPreference = accountData[CAMPAIGN_TYPES.DismissFeedback];
    const accountLevelRejected =
      accountPreference &&
      accountPreference[type] &&
      now < accountPreference[type];
    return !(userLevelRejected || accountLevelRejected);
  }

  getCampaignAdGroupsFromScope() {
    const { scope } = this.recommendationService;
    switch (scope.levelAt) {
      case levelAtConstant.CUSTOMER:
      case levelAtConstant.ACCOUNT:
        return [];
      case levelAtConstant.CAMPAIGN:
        return [{
          Key: parseInt(scope.campaignId, 10),
          Value: [],
        }];
      case levelAtConstant.ADGROUP:
        return [{
          Key: parseInt(scope.campaignId, 10),
          Value: [parseInt(scope.adGroupId, 10)],
        }];
      default:
        throw new Error('can not get the scope in recommendation service');
    }
  }

  updateFilterState(state) {
    this.view.filterState = _.extend(this.view.filterState, state);
  }
}
